/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * clarityrcm.api
 * OpenAPI spec version: 1.0
 */
import type {
  FeedbackResponse,
  PostApiFeedbackPracticeIdUploadBody,
} from "../../../../../lib/api-types/schemas";

import { authenticatedClient } from "../../authenticatedClient";
import { customFormDataFn } from "../../customFormDataFn";

/**
 * **Actor types:** `clinic`, `internal`

**Practice-scoped:** route `{practiceId}` must match the user's `practiceId` claims
 * @summary Submit in-app feedback (Question / Issue / Idea) that creates a Plane issue on the ClarityPay board
 */
export type postApiFeedbackPracticeIdUploadResponse200 = {
  data: FeedbackResponse;
  status: 200;
};

export type postApiFeedbackPracticeIdUploadResponse400 = {
  data: void;
  status: 400;
};

export type postApiFeedbackPracticeIdUploadResponse401 = {
  data: void;
  status: 401;
};

export type postApiFeedbackPracticeIdUploadResponse403 = {
  data: void;
  status: 403;
};

export type postApiFeedbackPracticeIdUploadResponse500 = {
  data: void;
  status: 500;
};

export type postApiFeedbackPracticeIdUploadResponseSuccess =
  postApiFeedbackPracticeIdUploadResponse200 & {
    headers: Headers;
  };
export type postApiFeedbackPracticeIdUploadResponseError = (
  | postApiFeedbackPracticeIdUploadResponse400
  | postApiFeedbackPracticeIdUploadResponse401
  | postApiFeedbackPracticeIdUploadResponse403
  | postApiFeedbackPracticeIdUploadResponse500
) & {
  headers: Headers;
};

export const getPostApiFeedbackPracticeIdUploadUrl = (practiceId: string) => {
  return `/api/feedback/${practiceId}/upload`;
};

export const postApiFeedbackPracticeIdUpload = async (
  practiceId: string,
  postApiFeedbackPracticeIdUploadBody: PostApiFeedbackPracticeIdUploadBody,
  options?: RequestInit,
): Promise<postApiFeedbackPracticeIdUploadResponseSuccess> => {
  const formData = customFormDataFn(postApiFeedbackPracticeIdUploadBody);
  return authenticatedClient<postApiFeedbackPracticeIdUploadResponseSuccess>(
    getPostApiFeedbackPracticeIdUploadUrl(practiceId),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};
